/* Stylesheet */

.qr_code_container {
  margin: 62px 0px 62px 0px;

  .info_message {
    p {
      margin: 21px 0px 21px 0px;
    }
    span {
      font-weight: 600;
    }
  }

  .qr_code {
    display: block;
    margin: 0 auto;
    height: auto;
    width: 172px;
    border-radius: 8px;
    box-shadow: var(--ion-box-shadow);
  }
}
